export default __webpack_public_path__ + "static/media/Sight Machine.6fa9bfae.png";